// import gsap from 'gsap'
import { isNil } from 'lodash-es'

export class AnimationQueue {
  queue: AnimateView[] = []
  current: number | null = null

  getCurrent() {
    if (!isNil(this.current)) return this.current
    const index = this.queue.findIndex(d => d.position === VIEW_POSITION.show)
    if (index !== -1) {
      this.current = index
    }
    return this.current
  }

  push(item: AnimateView) {
    if (!this.queue.find(d => item.id === d.id)) {
      this.queue.push(item)
    }
  }

  insert(item: AnimateView, index = 0) {
    if (!this.queue.find(d => item.id === d.id)) {
      this.queue.splice(index, 0, item)
    }
  }

  getItem(id) {
    const index = this.queue.findIndex(d => d.id === id)
    const item = this.queue[index]
    return [item, index] as [AnimateView, number]
  }

  // slideIn(id) {
  //   const [item]: [AnimateView, number] = this.getItem(id)
  //   item?.show?.()
  // }
  //
  // slideOut(id, duration?) {
  //   const [item]: [AnimateView, number] = this.getItem(id)
  //   item?.pass?.()
  // }
  //
  // slideBack(id, duration?) {
  //   const [item]: [AnimateView, number] = this.getItem(id)
  //   item?.hide?.()
  // }

  next() {
    const current = this.getCurrent()
    if (!isNil(current)) {
      if (current === this.queue.length - 1) {
        this.jumpStart()
      } else {
        this.queue[current].pass()
        this.queue[current + 1].show()
        this.current = current + 1
      }
    }
  }

  prev() {
    const current = this.getCurrent()
    if (!isNil(current) && current >= 0) {
      this.queue[current].hide()
      this.queue[current - 1].show()
      this.current = current - 1
    }
  }

  jumpStart() {
    const current = this.getCurrent()
    if (!isNil(current) && current !== 0) {
      this.queue[current].hide()
      for (let i = 1; i < this.queue.length; i++) {
        if (i !== current) {
          this.queue[i].hide()
        }
      }
      this.current = 0
      this.queue[this.current].show()
    }
  }

  jump(index: number) {
    const current = this.getCurrent()
    if (!isNil(current) && current !== index) {
      if (index > current) {
        this.queue[current].pass()
      } else {
        this.queue[current].hide()
      }
    }
    for (let i = 0; i < this.queue.length; i++) {
      if (i !== current) {
        this.queue[i].hide()
      }
    }
    this.current = index
    this.queue[this.current].show()
  }

  reset () {
    this.current = 0
  }
}

export enum VIEW_POSITION {
  pass = 'pass',
  show = 'show',
  hide = 'hide',
}

export class AnimateView {
  id: string | null = null
  position: VIEW_POSITION = VIEW_POSITION.hide
  el: any

  constructor(opts) {
    this.id = opts.id
    this.position = opts.position
    this.el = document.querySelector('#' + this.id)
    if (this.position === VIEW_POSITION.show) {
      this.show()
    } else if (this.position === VIEW_POSITION.hide) {
      this.hide()
    }
  }

  // 显示
  show() {
    this.el = document.querySelector('#' + this.id)
    this.el.style.visibility = 'visible'
    this.el.classList.remove('view-hide')
    this.el.classList.remove('view-slide-left')
    this.el.classList.add('view-show')
    this.position = VIEW_POSITION.show
  }

  // 去到左边
  pass() {
    this.el = document.querySelector('#' + this.id)
    this.el.classList.remove('view-show')
    this.el.classList.remove('view-hide')
    this.el.classList.add('view-slide-left')
    this.position = VIEW_POSITION.pass
  }

  // 回到初始位置
  hide() {
    this.el = document.querySelector('#' + this.id)
    this.el.classList.remove('view-show')
    this.el.classList.remove('view-slide-left')
    this.el.classList.add('view-hide')
    this.position = VIEW_POSITION.hide
  }
}

export default new AnimationQueue()
